import { render, staticRenderFns } from "./TabelaGestaoContratoOriginacao.vue?vue&type=template&id=85e318dc&lang=pug"
import script from "./TabelaGestaoContratoOriginacao.vue?vue&type=script&lang=js"
export * from "./TabelaGestaoContratoOriginacao.vue?vue&type=script&lang=js"
import style0 from "./TabelaGestaoContratoOriginacao.vue?vue&type=style&index=0&id=85e318dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports